import {
  MdOutlineEmail,
  MdOutlineChat,
  MdOutlineScience,
  MdOutlineStorage,
  MdOutlinePublic,
  MdOutlineSchool
} from 'react-icons/md'
import './contact.css'

const areas = [
  {
    icon: MdOutlineScience,
    title: 'Investigación y consultoría',
    description: 'Estudios sociales, demográficos, evaluaciones y asesoría metodológica.'
  },
  {
    icon: MdOutlinePublic,
    title: 'Análisis territorial',
    description: 'Indicadores, cartografía, desigualdades y análisis geoespacial.'
  },
  {
    icon: MdOutlineStorage,
    title: 'Desarrollo de software',
    description: 'Sistemas de gestión, mantenedores de datos y plataformas institucionales.'
  },
  {
    icon: MdOutlineSchool,
    title: 'Capacitación especializada',
    description: 'Formación en estadística, programación y análisis de datos.'
  }
]

const Contact = () => {
  return (
    <main className="demografica-contact">
      <section className="contact-hero">
        <div className="contact-hero__content">
          <p className="contact-eyebrow">DEMOGRÁFICA · CONTACTO</p>

          <h1>
            Conversemos sobre tu
            <span> próximo proyecto.</span>
          </h1>

          <p className="contact-hero__description">
            Transformamos preguntas complejas en investigaciones,
            indicadores y herramientas tecnológicas. Cuéntanos
            qué necesita tu organización y exploremos cómo colaborar.
          </p>

          <div className="contact-hero__actions">
            <a className="contact-btn contact-btn--primary" href="mailto:info@demografica.cl">
              Escribir un correo →
            </a>
            <a
              className="contact-btn contact-btn--secondary"
              href="https://wa.me/56975643583"
              target="_blank"
              rel="noopener noreferrer"
            >
              Conversar por WhatsApp →
            </a>
          </div>
        </div>

        <div className="contact-hero__visual">
          <div className="contact-visual-card">
            <span className="contact-visual-card__eyebrow">
              INVESTIGACIÓN · DATOS · TECNOLOGÍA
            </span>
            <h2>
              Buenas decisiones
              <span> comienzan con buenas preguntas.</span>
            </h2>
            <p>Conocimiento aplicado para comprender y transformar.</p>
            <div className="contact-visual-card__circle" aria-hidden="true" />
          </div>
        </div>
      </section>

      <section className="contact-channels" aria-labelledby="contact-channels-title">
        <div className="contact-section-heading">
          <p className="contact-eyebrow">CANALES DE CONTACTO</p>
          <h2 id="contact-channels-title">
            Estamos disponibles para <span>conversar.</span>
          </h2>
          <p>
            Elige el canal que te resulte más cómodo para plantear
            una consulta, solicitar información o proponer una colaboración.
          </p>
        </div>

        <div className="contact-channels__grid">
          <a className="contact-channel" href="mailto:info@demografica.cl">
            <div className="contact-channel__icon"><MdOutlineEmail /></div>
            <div>
              <h3>Correo electrónico</h3>
              <p>Para consultas, propuestas y antecedentes de proyectos.</p>
              <strong>info@demografica.cl →</strong>
            </div>
          </a>

          <a
            className="contact-channel"
            href="https://wa.me/56975643583"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="contact-channel__icon contact-channel__icon--green">
              <MdOutlineChat />
            </div>
            <div>
              <h3>WhatsApp</h3>
              <p>Un canal directo para iniciar una conversación.</p>
              <strong>Iniciar conversación →</strong>
            </div>
          </a>
        </div>
      </section>

      <section className="contact-services" aria-labelledby="contact-services-title">
        <div className="contact-section-heading">
          <p className="contact-eyebrow">ÁREAS DE COLABORACIÓN</p>
          <h2 id="contact-services-title">
            ¿En qué podemos <span>ayudarte?</span>
          </h2>
          <p>
            Integramos ciencias sociales, métodos cuantitativos
            y desarrollo tecnológico para responder a necesidades reales.
          </p>
        </div>

        <div className="contact-services__grid">
          {areas.map(({ icon: Icon, title, description }, index) => (
            <article className="contact-service" key={title}>
              <div className="contact-service__top">
                <span>{String(index + 1).padStart(2, '0')}</span>
                <Icon aria-hidden="true" />
              </div>
              <h3>{title}</h3>
              <p>{description}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="contact-process">
        <p className="contact-eyebrow">TRABAJEMOS JUNTOS</p>
        <h2>De una idea a una <span>solución concreta.</span></h2>
        <div className="contact-process__steps">
          <article>
            <span>01</span>
            <h3>Conversemos</h3>
            <p>Cuéntanos el problema, la necesidad o la idea inicial.</p>
          </article>
          <article>
            <span>02</span>
            <h3>Exploremos alternativas</h3>
            <p>Identificamos enfoques, herramientas y posibilidades de colaboración.</p>
          </article>
          <article>
            <span>03</span>
            <h3>Construyamos una propuesta</h3>
            <p>Definimos objetivos, alcance y una estrategia de trabajo.</p>
          </article>
        </div>
      </section>

      <section className="contact-cta">
        <div>
          <p className="contact-eyebrow">TU PROYECTO PUEDE COMENZAR AQUÍ</p>
          <h2>Hablemos de lo que necesitas.</h2>
          <p>
            Investigación, análisis de datos o desarrollo tecnológico:
            conversemos sobre las posibilidades.
          </p>
        </div>
        <a className="contact-btn contact-btn--white" href="mailto:info@demografica.cl">
          Escribir un correo →
        </a>
      </section>
    </main>
  )
}

export default Contact

